import * as uuid from 'uuid';

import { api } from 'common';

import { type ReactFlowBlockNode, type ReactFlowNode } from '../../../../types';
import { BlockType, FlowNodeType } from '../../../types';

export const defaultOutputNodeLabelPrefix = 'output';
export function getDefaultOutputNodeConfig(): api.FlowDefinition.OutputBlock['config'] {
  return {
    data: '',
  };
}

export function createOutputNode(props: Pick<ReactFlowNode, 'position'>): ReactFlowBlockNode {
  return {
    id: uuid.v4(),
    data: {
      uiBlockType: BlockType.Output,
      label: defaultOutputNodeLabelPrefix,
      config: getDefaultOutputNodeConfig(),
      returnType: api.FlowDefinition.ProducedType.Any,
    },
    type: FlowNodeType.Block,
    ...props,
  };
}
